// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"bb9bb324","453":"5d03039a","732":"a34c624e"}[chunkId] + ".chunk.js";
};